import { SPLIT_GROUPS, NodeConfig, FlowTypes } from '../types';

export const wait_for_menu: NodeConfig = {
  type: 'wait_for_menu',
  name: 'Wait for Menu Selection',
  group: SPLIT_GROUPS.wait,
  flowTypes: [FlowTypes.VOICE]
};
